const palettes = [
    ["#a6032f", "#022873", "#035aa6", "#04b2d9", "#05dbf2"],
    ["#03738c", "#037f8c", "#04d9d9", "#f28972", "#f20505"],
    ["#bf4e63", "#f2f2f2", "#d9ae5f", "#bf7d65", "#d9a38f"],
    ["#f2dcc9", "#593018", "#734c36", "#d9b6a3", "#0d0d0d"],
    ["#021f59", "#2c4001", "#f25c05", "#bf7665", "#a60303"],
    ["#d94e5a", "#012e40", "#add1d9", "#8c0303", "#a64b4b"],
    ["#32a65a", "#84d9a2", "#014005", "#f2f2f2", "#0d0d0d"],
    ["#1b3da6", "#26488c", "#2372d9", "#62abd9", "#f2d857"],
    ["#f21326", "#60bfbf", "#98d979", "#d99e30", "#f29999"],
    ["#3f0259", "#f2e205", "#f2b705", "#f2ebdc", "#d95e32"],
    ["#663f8c", "#038c4c", "#f29727", "#f25f29", "#bf2626"],
    ["#f21b2d", "#f23d5e", "#777cd9", "#525559", "#e9eff2"],
    ["#731a22", "#a63f48", "#bdd959", "#bfa095", "#8c5042"],
    ["#222e73", "#032ca6", "#85bff2", "#f2c84b", "#f29f05"],
    ["#a66a75", "#580259", "#f05cf2", "#f2e205", "#f2d43d"],
    ["#0476d9", "#05aff2", "#a4d932", "#f2be22", "#f2cc85"],
    ["#d99e30", "#a67a44", "#732002", "#d94625", "#400101"],
    ["#314259", "#d9843b", "#73310a", "#a64914", "#0d0d0d"],
    ["#204037", "#558c3b", "#9cd95f", "#bfa78a", "#f2541b"],
    ["#0442bf", "#5cacf2", "#f2b705", "#f29f05", "#f2b8a2"],
    ["#485922", "#798c35", "#b4bf5e", "#242614", "#f2f2f2"],
    ["#f2d8c9", "#260b01", "#73564c", "#bf9484", "#d9beb4"],
    ["#f2c063", "#a68446", "#d9a25f", "#8c6a3f", "#59452c"],
    ["#f2bb13", "#f28c0f", "#d9a577", "#a61b0f", "#f2f2f2"],
    ["#323e40", "#f2ab27", "#d97d0d", "#732002", "#d94d1a"],
    ["#264022", "#698c46", "#bf9278", "#d9ccc5", "#735e5a"],
    ["#0468bf", "#05aff2", "#f2b705", "#f28705", "#bf3604"],
    ["#730217", "#090b0d", "#f2cb05", "#594302", "#d94f30"],
    ["#bfa004", "#bf7e04", "#bf4904", "#bf1304", "#0d0d0d"],
    ["#d90d32", "#d3d9a7", "#f25116", "#bf3111", "#f2f2f2"],
    ["#f2cb05", "#f2b705", "#262523", "#d97904", "#d92818"],
    ["#7eb3bf", "#8c8630", "#f2f0ce", "#f2bb9b", "#d9765f"],
    ["#f26d85", "#bf214b", "#c1d0d9", "#0e6973", "#0e7373"],
    ["#224021", "#5f8c4a", "#59734d", "#35402d", "#592c22"],
    ["#034c8c", "#69a7bf", "#f2e205", "#f2cb05", "#f2d49b"],
    ["#bf2633", "#f2b90f", "#f2b33d", "#a67a29", "#a66249"],
    ["#eeeeee", "#00adb5", "#393e46", "#222831"],
    ["#6a2c70", "#b83b5e", "#f08a5d", "#f9ed69"],
    ["#95e1d3", "#eaffd0", "#fce38a", "#f38181"],
    ["#eaeaea", "#ff2e63", "#252a34", "#08d9d6"],
    ["#fc5185", "#f5f5f5", "#3fc1c9", "#364f6b"],
    ["#ffffd2", "#fcbad3", "#aa96da", "#a8d8ea"],
    ["#8785a2", "#f6f6f6", "#ffe2e2", "#ffc7c7"],
    ["#abedd8", "#46cdcf", "#3d84a8", "#48466d"],
    ["#112d4e", "#3f72af", "#dbe2ef", "#f9f7f7"],
    ["#ffde7d", "#f6416c", "#f8f3d4", "#00b8a9"],
    ["#53354a", "#903749", "#e84545", "#2b2e4a"],
    ["#311d3f", "#522546", "#88304e", "#e23e57"],
    ["#14ffec", "#0d7377", "#323232", "#212121"],
    ["#a5dee5", "#e0f9b5", "#fefdca", "#ffcfdf"],
    ["#61c0bf", "#bbded6", "#fae3d9", "#ffb6b9"],
    ["#ffaaa5", "#ffd3b6", "#dcedc1", "#a8e6cf"],
    ["#ff165d", "#ff9a00", "#f6f7d7", "#3ec1d3"],
    ["#521262", "#6639a6", "#3490de", "#6fe7dd"],
    ["#355c7d", "#6c5b7b", "#c06c84", "#f67280"],
    ["#ffd460", "#f07b3f", "#ea5455", "#2d4059"],
    ["#edb1f1", "#d59bf6", "#9896f1", "#8ef6e4"],
    ["#99ddcc", "#f6f6f6", "#ffe2e2", "#bad7df"],
    ["#c4edde", "#7ac7c4", "#f73859", "#384259"],
    ["#cabbe9", "#ffcef3", "#fdfdfd", "#a1eafb"],
    ["#283c63", "#928a97", "#fbe8d3", "#f85f73"],
    ["#fecea8", "#ff847c", "#e84a5f", "#2a363b"],
    ["#1e2022", "#52616b", "#c9d6df", "#f0f5f9"],
    ["#ff7e67", "#fafafa", "#a2d5f2", "#07689f"],
    ["#fbafaf", "#f2c6b4", "#f3e8cb", "#99e1e5"],
    ["#a6d0e4", "#f9ffea", "#ffecda", "#d4a5a5"],
    ["#eeeeee", "#d72323", "#3a4750", "#303841"],
    ["#c5e3f6", "#fc5c9c", "#fccde2", "#fcefee"],
    ["#7e6bc4", "#c79ecf", "#d6c8ff", "#fef0ff"],
    ["#ed8d8d", "#8d6262", "#4d4545", "#393232"],
    ["#dbedf3", "#f73859", "#404b69", "#283149"],
    ["#fa4659", "#f0fff3", "#c6f1e7", "#11cbd7"],
    ["#537780", "#11d3bc", "#55e9bc", "#fffcca"],
    ["#f5c7f7", "#a393eb", "#5e63b6", "#27296d"],
    ["#004a7c", "#005691", "#e8f1f5", "#fafafa"],
    ["#ffc93c", "#ff9a3c", "#ff6f3c", "#155263"],
    ["#fff5a5", "#ffaa64", "#ff8264", "#ff6464"],
    ["#7098da", "#6eb6ff", "#90f2ff", "#e0fcff"],
    ["#f3f798", "#eab4f8", "#fcc8f8", "#c7f5fe"],
    ["#e3e3e3", "#f95959", "#455d7a", "#233142"],
    ["#f5f5f5", "#d3d4d8", "#3fbac2", "#4d606e"],
    ["#bfcfff", "#c8e7ed", "#ffffc2", "#ffa5a5"],
    ["#625772", "#f38181", "#fefaec", "#a9eee6"],
    ["#ffbd39", "#e61c5d", "#930077", "#3a0088"],
    ["#8971d0", "#7dace4", "#95e8d7", "#adf7d1"],
    ["#e67a7a", "#ffebb7", "#fff4e1", "#9ddcdc"],
    ["#d9faff", "#00bbf0", "#005792", "#00204a"],
    ["#f76b8a", "#fcfefe", "#eaf6f6", "#66bfbf"],
    ["#6c5b7c", "#c06c84", "#f67280", "#f8b595"],
    ["#4a266a", "#7f4a88", "#de95ba", "#ffd9e8"],
    ["#ff7c38", "#e03e36", "#b80d57", "#700961"],
    ["#2f9296", "#46b7b9", "#87dfd6", "#dff5f2"],
    ["#f67280", "#c06c84", "#6c5b7b", "#35477d"],
    ["#7c7575", "#b8b0b0", "#dfd3d3", "#fbf0f0"],
    ["#00fff5", "#00adb5", "#393e46", "#222831"],
    ["#1f4e5f", "#79a8a9", "#aacfd0", "#f4f7f7"],
    ["#80d6ff", "#edf798", "#fab57a", "#f06868"],
    ["#8f8787", "#ebcbae", "#f9f9f9", "#a6e4e7"],
    ["#2eb872", "#a3de83", "#feffe4", "#fa4659"],
    ["#355c7d", "#c06c84", "#f67280", "#f8b195"],
    ["#d988bc", "#ffa8b8", "#ffd2a5", "#ffffc1"],
    ["#70a1d7", "#a1de93", "#f7f48b", "#f47c7c"],
    ["#69D2E7", "#A7DBD8", "#E0E4CC", "#F38630", "#FA6900"],
    ["#FE4365", "#FC9D9A", "#F9CDAD", "#C8C8A9", "#83AF9B"],
    ["#ECD078", "#D95B43", "#C02942", "#542437", "#53777A"],
    ["#556270", "#4ECDC4", "#C7F464", "#FF6B6B", "#C44D58"],
    ["#490A3D", "#BD1550", "#E97F02", "#F8CA00", "#8A9B0F"],
    ["#594F4F", "#547980", "#45ADA8", "#9DE0AD", "#E5FCC2"],
    ["#00A0B0", "#6A4A3C", "#CC333F", "#EB6841", "#EDC951"],
    ["#E94E77", "#D68189", "#C6A49A", "#C6E5D9", "#F4EAD5"],
    ["#3FB8AF", "#7FC7AF", "#DAD8A7", "#FF9E9D", "#FF3D7F"],
    ["#FF4E50", "#FC913A", "#F9D423", "#EDE574", "#E1F5C4"],
    ["#99B898", "#FECEA8", "#FF847C", "#E84A5F", "#2A363B"],
    ["#655643", "#80BCA3", "#F6F7BD", "#E6AC27", "#BF4D28"],
    ["#00A8C6", "#40C0CB", "#F9F2E7", "#AEE239", "#8FBE00"],
    ["#8a00d4", "#d527b7", "#f782c2", "#f9c46b", "#e3e3e3"],
    ["#e74645", "#fb7756", "#facd60", "#fdfa66", "#1ac0c6"],
    ["#454d66", "#309975", "#58b368", "#dad873", "#efeeb4"],
    ["#361d32", "#543c52", "#f55951", "#edd2cb", "#f1e8e6"],
    ["#072448", "#54d2d2", "#ffcb00", "#f8aa4b", "#ff6150"],
    ["#12492f", "#0a2f35", "#f56038", "#f7a325", "#ffca7a"],
    ["#122c91", "#2a6fdb", "#48d6d2", "#81e9e6", "#fefcbf"],
    ["#27104e", "#64379f", "#9854cb", "#ddacf5", "#75e8e7"],
    ["#f7a400", "#3a9efd", "#3e4491", "#292a73", "#1a1b4b"],
    ["#343090", "#5f59f7", "#6592fd", "#44c2fd", "#8c61ff"],
    ["#1f306e", "#553772", "#8f3b76", "#c7417b", "#f5487f"],
    ["#f9b4ab", "#fdebd3", "#264e70", "#679186", "#bbd4ce"],
    ["#492b7c", "#301551", "#ed8a0a", "#f6d912", "#fff29c"],
    ["#ffa822", "#134e6f", "#ff6150", "#1ac0c6", "#dee0e6"]
]

export default function getRandomPalette(rnd = Math.random(), filter) {
    const selection = typeof filter === "function" ? palettes.filter(filter) : palettes
    return selection[0 | rnd * selection.length]
}
